import Modal from 'react-modal'
import PropTypes from 'prop-types'

import { ReactComponent as ModalXIcon } from '../../../../assets/images/common/icons/modal-X-icon.svg'
import { ReactComponent as LiveProgramIcon } from '../../../../assets/images/common/icons/programBuilder/live-program-icon.svg'
import { ReactComponent as DraftProgramIcon } from '../../../../assets/images/common/icons/programBuilder/draft-program-icon.svg'
import { ReactComponent as OpenEyeIcon } from '../../../../assets/images/common/icons/open-eye-icon.svg'
import { ReactComponent as ClosedEyeIcon } from '../../../../assets/images/common/icons/closed-eye-icon.svg'
import { ReactComponent as LockIcon } from '../../../../assets/images/common/icons/lock-icon.svg'
import SubmitButton from '../../../common/buttons/SubmitButton'

import './LiveModal.scss'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const LiveModal = ({ program, showModal, onClose }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const programPage = `${window.location.origin}/landing/${program.communityId}/class/${program.id}`

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={onClose}
      contentLabel={t('programs.builder.liveModal.contentLabel')}
      className='live-program-builder-modal-content'
      autoFocus
    >
      <div id='LiveModal'>
        <div className='animated fadeIn'>
          <div>
            <div className='d-flex justify-content-end text-align-right'>
              <ModalXIcon id='modalXIcon' onClick={onClose} />
            </div>
            <div className='d-flex flex-column justify-content-center align-items-center'>
              {program.isDraft ? <DraftProgramIcon id='mainIcon' /> : <LiveProgramIcon id='mainIcon' />}
              <p className='title'>
                {program.isDraft ? t('programs.builder.liveModal.titleDraft') : t('programs.builder.liveModal.titleLive')}
              </p>
              <p className='text-center message'>
                {program.isDraft
                  ? t('programs.builder.liveModal.savedAsDraft', { name: program.name || '' })
                  : t('programs.builder.liveModal.liveNow', { name: program.name })}
              </p>
              <div className='d-flex align-items-center message'>
                {program.visibility === 'public' && <OpenEyeIcon className='open-eye-icon' style={{ flexShrink: '0', marginRight: '8px' }} />}
                {program.visibility === 'unlisted' && <ClosedEyeIcon className='closed-eye-icon' style={{ flexShrink: '0', marginRight: '8px' }} />}
                {program.visibility === 'private' && <LockIcon className='lock-icon' style={{ flexShrink: '0', marginRight: '8px' }} />}

                {t('programs.builder.liveModal.visibilityLabel', { visibility: t(`programs.common.visibility.${program.visibility}`) })}
              </div>
              {(!program.isDraft && program.visibility !== 'private') && (
                <div className='d-flex align-items-center w-100 justify-content-between mt-2 px-2'>
                  <div className='link-container'>
                    <p className='program-page'>{t('programs.builder.liveModal.linkToProgramPage')}</p>
                    <a className='link-program-page' href={programPage} target='_blank'>
                      {programPage}
                    </a>
                  </div>
                  <button
                    className='btn btn-primary navy-button copy-link-button ml-2'
                    onClick={() => navigator.clipboard.writeText(programPage)}
                  >
                    {t('programs.builder.liveModal.copyLink')}
                  </button>
                </div>
              )}
            </div>
            <div className='row py-3'>
              <div className='col-12'>
                {(!program.isDraft && program.visibility !== 'private')
                  ? (
                    <SubmitButton
                      onClick={() => navigate(`/landing/${program.community_id}/class/${program.id}`)}
                      buttonMessage={t('programs.builder.liveModal.viewRegistrationPage')}
                      buttonColor='orange-button'
                    />
                  ) : (
                    <SubmitButton
                      onClick={() => navigate(`/programs/${program.id}/edit`)}
                      buttonMessage={t('programs.builder.liveModal.goBackToEditing')}
                      buttonColor='orange-button'
                    />
                  )
                }
              </div>
              <div className='col-12'>
                <SubmitButton
                  onClick={onClose}
                  buttonMessage={t('common.close')}
                  buttonColor='navy-button'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

LiveModal.propTypes = {
  program: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default LiveModal
